var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-search-view"},[(_vm.isEmpty)?_c('span',{staticClass:"u-list-empty"},[_vm._v("👻 暂无记录")]):_vm._e(),(_vm.list)?_c('knowledgeList',{attrs:{"list":_vm.list,"total":_vm.total,"pagination":_vm.pagination},on:{"onPageKey":_vm.onPageKey}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }